import React from 'react'
import _ from 'lodash';
import EditPageDocsGenerateModal from '../configuration/edit-page/EditPageDocsGenerateModal'
import FieldSelect from '../configuration/fields/FieldSelect';
import * as Row from '../layout/Row';
import ProjectStore from '../../store/projectStore';

export default class ProjectDocumentationModal extends EditPageDocsGenerateModal {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            languageId: null,
            selectedSections: [],
            selectedConfigurations: [],
            projectChecked: false,
            projectSparePartsListChecked: false
        }
    }

    getWidth() {
        return 'auto';
    }

    thenFetchModalData(response) {
        this.setState({
            model: response.data,
            selectedConfigurations: response.data.configurations.value.map(x => x.id),
            languageId: response.data.language.value,
            isLoading: false
        });
    }

    getDocumentationModalContentData() {
        return this.props.id
    }

    onLanguageChange = item => {
        this.setState({
            languageId: item
        })
    }

    onTechnicalSpecificationItemChange = item => {
        this.setState({
            technicalSpecification: item.value
        })
    }

    renderBody() {
        const languages = this.state.isLoading ? [] : this.state.model.language.items
        return (
            <div className="project-documentation-modal">
                <div className="left">
                    <div className="text-muted" style={{paddingBottom: '0.5rem'}}>{__('Project')}</div>
                    {this.renderProjectCheckbox()}
                    <div className="text-muted"
                         style={{paddingBottom: '0.5rem', paddingTop: '1rem'}}>{__('Specification scope')}</div>
                    {this.renderTechnicalSpecificationItems()}
                    <div className="text-muted"
                         style={{paddingBottom: '0.5rem', paddingTop: '1rem'}}>{__('Substations')}</div>
                    {this.state.model.outcomes.items.map(this.renderSectionCheckbox)}
                    {this.isOrder() && this.renderProjectSparePartsListCheckbox()}

                    <Row.Container hasOuterGutter={false} className="flex-center-v" style={{paddingTop: '1rem'}}>
                        <Row.Column6>
                            <div className="text-muted">{__('Language')}</div>
                        </Row.Column6>
                        <Row.Column6>
                            <FieldSelect
                                items={languages}
                                value={this.state.languageId}
                                onChange={this.onLanguageChange}
                            />
                        </Row.Column6>
                    </Row.Container>
                </div>
                {this.renderConfigurations()}
            </div>
        )
    }

    renderConfigurations = () => (
        <div className="right">
            <div className="text-muted" style={{paddingBottom: '0.5rem'}}>{__('Configurations')}</div>
            <div className="configurations">
                {this.state.model.configurations.value.map(x => (
                    <div className="configuration">
                        <input id={x.id} type="checkbox" checked={this.state.selectedConfigurations.includes(x.id)}
                               onChange={() => this.onConfigurationClick(x.id)}/>
                        <label htmlFor={x.id}>{x.name}</label>
                        {x.canSetProductSerialNumber && this.renderProductSerialNumber(x)}
                        {x.preffered === false ? <React.Fragment/> : (
                            <div className="preffered">
                                {__('Preffered')}
                            </div>
                        )}
                    </div>
                ))}
            </div>

        </div>
    )

    onConfigurationClick = id => {
        this.setState(prev => ({
            selectedConfigurations: _.xor(prev.selectedConfigurations, [id])
        }))
    }

    renderProductSerialNumber = configuration => {
        if (configuration.productSerialNumber) {
            return (
                <span
                    className="configuration-product-serial-number">{__('S/N')}: {configuration.productSerialNumber}</span>
            )
        } else {
            return (
                <span className="configuration-product-serial-number --missing">{__('S/N: not available')}</span>
            )
        }
    }

    renderProjectCheckbox = () => {
        const onProjectChange = (event) => {
            this.setState({projectChecked: event.target.checked});
        }
        const idx = this.props.id;
        const item = {text: __("Substation table"), value: idx};
        const checked = this.state.projectChecked;

        return this.renderCheckbox(item, idx, checked, onProjectChange);
    }

    renderProjectSparePartsListCheckbox = () => {
        const onChange = (event) => {
            this.setState({projectSparePartsListChecked: event.target.checked});
        }
        const idx = Math.random();
        const item = {text: __("Project spare parts list"), value: idx};
        const checked = this.state.projectSparePartsListChecked;

        return this.renderCheckbox(item, idx, checked, onChange);
    }

    renderSectionCheckbox = (item, idx) => {
        const onChange = () => {
            let selectedSections = this.state.selectedSections || []
            if (selectedSections.includes(item.value)) {
                selectedSections.splice(selectedSections.indexOf(item.value), 1)
            } else {
                selectedSections.push(item.value)
            }

            this.setState({
                selectedSections: selectedSections
            })
        };
        const checked = this.state.selectedSections.includes(item.value);

        return this.renderCheckbox(item, idx, checked, onChange);
    }

    renderCheckbox = (item, idx, checked, onChange) => {
        const id = Math.random();

        return (
            <div key={idx} style={{padding: '4px 0 4px 20px'}}>
                <input id={id} type="checkbox" checked={checked} onChange={onChange}/>
                <label htmlFor={id}>{item.text}</label>
            </div>
        );
    }

    renderTechnicalSpecificationItems() {
        let option = this.state.technicalSpecification === undefined
            ? this.state.model.technicalSpecification.value
            : this.state.technicalSpecification;

        return (
            <fieldset id="tsitem" className="configuration-editor-docs-generate-ts">
                {this.state.model.technicalSpecification.items.map((item, idx) => (
                    <div key={idx} className="configuration-editor-docs-generate-tsitem">
                        <input id={`tsitem${idx}`} type="radio" name="tsitem" checked={option === item.value}
                               onChange={() => this.onTechnicalSpecificationItemChange(item)}/>
                        <label htmlFor={`tsitem${idx}`}>{item.text}</label>
                    </div>
                ))}
            </fieldset>
        )
    }

    buildPostModel() {
        let projects = this.state.projectChecked ? [2] : [];
        return {
            id: this.props.id,
            type: 'Substation',
            projects: projects,
            language: this.state.languageId,
            outcomes: this.state.selectedSections,
            technicalSpecification: this.state.technicalSpecification,
            projectSparePartsListChecked: this.state.projectSparePartsListChecked,
            subStatusName: ProjectStore.formModel.generalInformation.subStatusName.value,
            factoryDiscount: ProjectStore.formModel.summary.factoryDiscountValue.value,
            responsible: ProjectStore.formModel.generalInformation.responsible.value,
            documentNumber: ProjectStore.formModel.generalInformation.number.value,
            name: ProjectStore.formModel.generalInformation.name.value,
            so: ProjectStore.formModel.generalInformation.so.value,
            po: ProjectStore.formModel.generalInformation.po.value,
            configurations: this.state.selectedConfigurations.map(x => ({
                id: x
            }))
        }
    }

    getDocumentType() {
        return 'Project';
    }

    isOrder = () => {
        const status = ProjectStore.formModel.generalInformation.status.value;
        return status === 'Order' || status === 'ProductionOrder';
    }
}